import styled from 'styled-components'
import { Flex, TextV2 as Text } from '@pinchenterprisesnpm/friday-ui'

interface CustomBannerContainerProps {
  backgroundColor: string
  marginLeft: string
  marginRight: string
  marginTop: string
  marginBottom: string
}

interface CustomBannerTextProps {
  textColor: string
}

export const CustomBannerContainer = styled(Flex)<CustomBannerContainerProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 4px;
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
`

export const CustomBannerText = styled(Text)<CustomBannerTextProps>`
  color: ${({ textColor }) => textColor};
`
